import CryptoJS from 'crypto-js'

// 与后端 app.security 配置一致的密钥（上线前应更换并同步两端）
const SECRET = 'sport-ai-secret-2026'
const AES_KEY = CryptoJS.enc.Hex.parse('a1b2c3d4e5f60718293a4b5c6d7e8f9a') // 16字节hex

/**
 * 生成请求签名头：X-Timestamp + X-Nonce + X-Sign
 */
export function buildSignHeaders() {
  const timestamp = Date.now().toString()
  const nonce = CryptoJS.lib.WordArray.random(16).toString()
  const sign = CryptoJS.MD5(timestamp + nonce + SECRET).toString()
  return { 'X-Timestamp': timestamp, 'X-Nonce': nonce, 'X-Sign': sign }
}

/**
 * 解密后端加密响应
 * @param {string} data Base64(IV + AES密文)
 * @param {string} sign 响应签名(HMAC-SHA256 前32位hex)
 * @returns {object} 原始响应对象
 */
export function decryptResponse(data, sign) {
  // 1. 验签（防响应被篡改）
  if (sign) {
    const expect = CryptoJS.HmacSHA256(data, SECRET).toString().substring(0, 32)
    if (expect.toLowerCase() !== sign.toLowerCase()) {
      throw new Error('响应验签失败')
    }
  }
  // 2. Base64 解码 → 前16字节为 IV，其余为密文
  const decoded = CryptoJS.enc.Base64.parse(data)
  const iv = CryptoJS.lib.WordArray.create(decoded.words.slice(0, 4), 16)
  const ciphertext = CryptoJS.lib.WordArray.create(decoded.words.slice(4), decoded.sigBytes - 16)
  const cipherParams = CryptoJS.lib.CipherParams.create({ ciphertext })
  // 3. AES-CBC 解密
  const decrypted = CryptoJS.AES.decrypt(cipherParams, AES_KEY, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })
  return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8))
}
